var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, ViewContainerRef } from '@angular/core';
// import {TranslateService} from 'ng2-translate';
import { ToastsManager } from 'ng2-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from './toastr.service';
import { BillingService } from './billing/billing.service';
import { SettingsService } from './settings/settings.service';
import { LoaderService } from './loader.service';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../environments/environment';
var AppComponent = /** @class */ (function () {
    function AppComponent(translate, billingService, toastr, vcr, router, toastrs, settings, loaderService, route) {
        var _this = this;
        this.translate = translate;
        this.billingService = billingService;
        this.toastr = toastr;
        this.vcr = vcr;
        this.router = router;
        this.toastrs = toastrs;
        this.settings = settings;
        this.loaderService = loaderService;
        this.route = route;
        var lang = localStorage.getItem('Applanguage');
        // console.log(lang + ' appLanguage');
        translate.addLangs(['en', 'es', 'fr']);
        translate.setDefaultLang('en');
        var browserLang = translate.getBrowserLang();
        //  translate.use(browserLang.match(/en|es/) ? browserLang : lang);
        translate.use(lang);
        this.toastr.setRootViewContainerRef(vcr);
        // this.getTranslation('es');
        //  this.getCredits();
        // this.settings.getCategory().subscribe((res) => {
        //   this.category = res.businessType;
        // });
        this.objLoaderStatus = false;
        if (environment.production) {
            this.route.params.subscribe(function () {
                _this.domain = window.location.href.replace(/(https?:\/\/)?(www.)?/i, '');
                _this.domainName = _this.domain.split('.')[1];
                // this.domainName = 'xquara';
                // this.domainName = 'vein-fast';
                if (_this.domainName === "xquara") {
                    localStorage.setItem('loginurl', 'https://resellersdelif.deliforce.io/xquara/loginIcon.png');
                    localStorage.setItem('navigationurl', 'https://resellersdelif.deliforce.io/xquara/navigationIcon-white.png');
                }
                else if (_this.domainName === "vein-fast") {
                    localStorage.setItem('loginurl', 'https://resellersdelif.deliforce.io/veinfast/logo-brand.png');
                    localStorage.setItem('navigationurl', 'https://resellersdelif.deliforce.io/veinfast/logo-dashboard.png');
                }
                else {
                    localStorage.setItem('loginurl', 'https://trackingdf.deliforce.io/brand.png');
                    localStorage.setItem('navigationurl', 'https://trackingdf.deliforce.io/title_icon.png');
                }
            });
        }
    }
    AppComponent.prototype.changeLanguage = function (lang) {
        this.translate.use(lang);
    };
    AppComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loaderService.loaderStatus.subscribe(function (val) {
            _this.objLoaderStatus = val;
        });
    };
    AppComponent = __decorate([
        Component({
            selector: 'app-root',
            template: require("./app.component.html"),
            styles: [require("./global-css/global.component.scss"), require("./global-css/fonts/font/flaticon.css"), require("./global-css/fonts/font-awesome/css/font-awesome.min.css"), require("./global-css/global.responsive.scss"), require("./global-css/global.component.css")],
            providers: []
        }),
        __metadata("design:paramtypes", [TranslateService, BillingService,
            ToastsManager, ViewContainerRef,
            Router, ToastrService,
            SettingsService, LoaderService, ActivatedRoute])
    ], AppComponent);
    return AppComponent;
}());
export { AppComponent };



//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.ts
// module id = ./src/app/app.component.ts
// module chunks = main